(function () {
  'use strict';

  angular
    .module('dashboard.memberships')
    .config(config);

  function config() {
  }
}());
